






























import { Prop, Component, Vue } from "vue-property-decorator";

export interface PreviewAction {
  key: string;
  icon: string;
  title: string;
  variant: string;
  click(): void;
}

@Component({})
export default class VPreview extends Vue {
  @Prop() size!: string;
  @Prop({ default: () => [] }) actions!: PreviewAction[];

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }
}
